import type { ITariffZoneDetails } from '../../../models/tariff-zone-details.model';

export class TariffZoneDetailsApiModel {
  public static mapToBusiness(tariffZone: TariffZoneDetailsApiModel): ITariffZoneDetails {
    return {
      number: tariffZone.number,
      name: tariffZone.name,
      shortName: tariffZone.shortName,
      wkt: tariffZone.wkt,
    };
  }

  public number!: number;
  public name!: string;
  public shortName!: string;
  public wkt!: string;
}
